import { render, staticRenderFns } from "./BackPage.vue?vue&type=template&id=466fbd59"
import script from "./BackPage.vue?vue&type=script&lang=ts"
export * from "./BackPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports